import * as React from 'react';
import { UNLEASH_FEATURE_NAMES } from '../../shared/unleash/feature-names';
import { getConfig, getThresholdProximityFromExperiment } from '../config';
import { useShowTag } from '../hooks/ad';
import { useMemo } from 'react';

export type Props = {
    id: string;
    targetId: string;
    pageType?: string;
    className?: string;
    deviceType?: string;
    vertical?: string;
    proximity?: number;
    threshold?: number;
};

function useGetProximityAndThresholdFromExperiments(
    defaultProximity: number = 0,
    defaultThreshold: number = 0,
) {
    const { proximity, threshold } = useMemo(() => {
        const srE = getThresholdProximityFromExperiment(
            UNLEASH_FEATURE_NAMES.enableSearchFirstResultHalfProx,
        );
        // object page experiment
        const opE = getThresholdProximityFromExperiment(
            UNLEASH_FEATURE_NAMES.objectPageInScreenExperiment,
        );
        if (srE || opE) {
            const proximity = srE?.proximity || opE?.proximity;
            const threshold = srE?.threshold || opE?.threshold;
            return {
                proximity: proximity || defaultProximity,
                threshold: threshold || defaultThreshold,
            };
        } else
            return { proximity: defaultProximity, threshold: defaultThreshold };
    }, [defaultProximity, defaultThreshold]);
    // search result experiment

    return { proximity, threshold };
}

export function Banner(props: Props) {
    const {
        id,
        targetId,
        pageType,
        className = 'ads__unit ads__unit--banner ads__unit--fullwidth',
        proximity = 100,
        threshold = 0.0,
    } = props;
    const { proximity: _proximity, threshold: _threshold } =
        useGetProximityAndThresholdFromExperiments(proximity, threshold);

    useShowTag(targetId, _proximity, _threshold);

    if (pageType && pageType === 'object') {
        // Rendered from objectpages-podium already
        return null;
    }
    const { vertical } = getConfig();
    let containerClassName = className;
    let boardClassName = `inline-container ${id}-inline-container`;

    // These styles apply only to some verticals because the new styles are applied there.
    // The other verticals will forego a transition to these new styles eventually.
    // After adding these styles, it means removing the ads__unit styling from the components
    if (vertical === 'realestate' && pageType === 'result') {
        containerClassName =
            'grid overflow-hidden relative transition-all outline-none mt-24 mx-16 mb-16 sm:mb-24';
        boardClassName = 'inline mx-auto';
    }
    return (
        <div id={`${targetId}-container`} className={containerClassName}>
            <div id={targetId} className={boardClassName}>
                <span className="ad-info-wrap">
                    <div
                        id={`${targetId}-button`}
                        className="ad-info"
                        style={{ maxWidth: 26, maxHeight: 26 }}
                    />
                </span>
            </div>
        </div>
    );
}
